import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "../views/pages/MainPages/Dashboard/Dashboard";
import Exactness from "../views/pages/MainPages/Exactness/Exactness";
import Api from "../views/pages/MainPages/Api/Api";
import Bulk from "../views/pages/MainPages/Bulk/Bulk";
import Extension from "../views/pages/MainPages/Extension/Extension";
import Contact from "../views/pages/MainPages/Contact/Contact";
import Pricing from "../views/pages/MainPages/Pricing/Pricing";
import Zapier from "../views/pages/MainPages/Zapier/Zapier";
import Layout from "./Layout";
import LegalContentDisplay from "../ui-components/LandingPage/LegalContentUi/LegalContentDisplay";
import ComparisonDisplay from "../ui-components/LandingPage/ComparisonContentUi/ComparisonDisplay";
import ConfirmationPage from "../ui-components/LandingPage/CommonUi/Confirm";

const MainRoutes = () => {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        {/* Public Routes */}
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/exactness" element={<Exactness />} />
          <Route path="/api" element={<Api />} />
          <Route path="/bulk" element={<Bulk />} />
          <Route path="/zapier" element={<Zapier />} />
          <Route path="/extension" element={<Extension />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal/:topic" element={<LegalContentDisplay />} />
          <Route path="/comparison/:topic" element={<ComparisonDisplay />} />
        </Route>
        <Route
          path="/email-confirmation/:email"
          element={<ConfirmationPage />}
        />
      </Routes>
    </Router>
  );
};

export default MainRoutes;
